export default "/images/vendor/flag-icon-css/flags/1x1/gb-nir.svg?f9fcc604971f0e53b88d3edf29000e85";